import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="contacto" className="py-20 lg:py-28 bg-gradient-to-br from-primary to-[#0F3BA8] text-white overflow-hidden relative" data-id="element-22">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20 pointer-events-none" data-id="element-23">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[100%] rounded-full bg-white blur-3xl" data-id="element-24" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[100%] rounded-full bg-accent blur-3xl" data-id="element-25" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-26">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white tracking-tight" data-id="element-27">
          ¿Listo para llenar tu agenda?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-2xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-28">
          Hablemos hoy y te mostramos cómo hacer crecer tu negocio local.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-29">
          <a href="https://wa.me/525539555333" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-5 bg-white text-primary text-lg font-bold rounded-xl hover:bg-gray-50 hover:scale-105 transition-all duration-300 shadow-xl" data-id="element-30">
            💬 Escríbenos por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}